// extracted by mini-css-extract-plugin
export default {"favText":"Notification_favText__pkwkG"};